import React from 'react';
import { useSelector } from 'react-redux';
import isPlainObject from 'lodash/isPlainObject';
import validateADGroupAgainstUserRoles from 'modules/shell/utils/userRoles';

/**
 * determines if the current user has one of provided AD user groups
 * {
 *  isStoreAssociate: 'store_associate',
 *  isBGStylist: {role: 'stylist', brand: 'BG'},
 * }
 * @returns {function(*): function(*=, *): *}
 */
export const withUserGroupMembership =
  (userGroupsMap = {}) =>
  (Component) => {
    const UserGroupMembershipConsumer = (props) => {
      //* We convert array into a string so validateADGroupAgainstUserRoles
      //* could recognize the AdGroup regardless of number of items in the array.
      let assignedADGroup = useSelector((state) => state?.user?.data?.groups || '').toString();
      // reassign the active ADGroup if the user is super user
      const isSuperUser = useSelector((state) => state?.user?.data?.isSuperUser || false);

      if (isSuperUser) {
        assignedADGroup = useSelector((state) => state?.userGroups?.activeADGroup);
      }

      const userGroupMembershipProps = Object.entries(userGroupsMap).reduce((res, [propName, payload]) => {
        let userRole;
        let brand;

        if (isPlainObject(payload)) {
          userRole = payload.role;
          // eslint-disable-next-line prefer-destructuring
          brand = payload.brand;
        } else {
          userRole = payload;
        }

        res[propName] = validateADGroupAgainstUserRoles({
          userRoles: [userRole],
          assignedADGroup,
          brand,
        });

        return res;
      }, {});

      return <Component {...props} {...userGroupMembershipProps} />;
    };

    UserGroupMembershipConsumer.displayName = `UserGroupMembershipConsumer(${Component.displayName || Component.name})`;

    return UserGroupMembershipConsumer;
  };

export default withUserGroupMembership;
